import React from "react"

const ChargeListContext = React.createContext(null as any)

export default ChargeListContext